export default {
  en: {
    title: 'Link a channel for notifications',
    close: 'Close',
    telegramLinked: 'Telegram linked',
    telegramLink: 'Link Telegram',
    hint: 'Subscribe to the bot to receive order notifications so the courier can contact you',
    telegramSubscribeTitle: 'Telegram subscription',
    step1Title: 'Step 1 – open the bot',
    step2Title: 'Step 2 – check the bot link',
    checkLink: 'Check link',
    checkingLink: 'Checking…',
    telegramSubscribeHint: 'Linking the bot is required to receive order notifications',
    checkSuccess: 'Telegram linked',
    checkNotLinked: 'Telegram is not linked yet. Open the bot, press Start, then try again.',
    checkFailed: 'Could not check the Telegram link. Try again later.',
    contactNotFound:
      'Bot contact not found. Open the bot via the button above, press Start, then check again.',
  },
  ru: {
    title: 'Привяжите канал для уведомлений',
    close: 'Закрыть',
    telegramLinked: 'Telegram привязан',
    telegramLink: 'Привязать Telegram',
    hint: 'Подпишитесь на бота для получения уведомлений о заказе для того, чтобы курьер смог с вами связаться',
    telegramSubscribeTitle: 'Подписка на Telegram',
    step1Title: 'Шаг 1 – перейдите в бота',
    step2Title: 'Шаг 2 – Проверьте привязку к боту',
    checkLink: 'Проверить привязку',
    checkingLink: 'Проверяем…',
    telegramSubscribeHint: 'Привязка к боту нужна для получения уведомлений о заказах',
    checkSuccess: 'Telegram привязан',
    checkNotLinked:
      'Telegram ещё не привязан. Откройте бота, нажмите Start и попробуйте снова.',
    checkFailed: 'Не удалось проверить привязку. Попробуйте позже.',
    contactNotFound:
      'Контакт бота не найден. Откройте бота по кнопке выше, нажмите Start и проверьте снова.',
  },
}
